import { SUBSCRIPTION_BANNER_REQUEST_PARAM } from '../../../utils/constants/AppConstants';

const generateSubscriptionBannerRequestObj = () => {
  const { id, page, limit, country, translation } =
    SUBSCRIPTION_BANNER_REQUEST_PARAM;

  const requestObj = {
    id,
    filter: {
      page,
      limit,
      country,
      translation
    }
  };

  return requestObj;
};

export default generateSubscriptionBannerRequestObj;
